// extracted by mini-css-extract-plugin
export var cartIcon = "_ov-0";
export var cartIconContainer = "_ov-1";